import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
}))
